module.exports = __webpack_public_path__ + "assets/img/img210.3447ecb5.png";